<header class="adv-sticky">
  <ups-navbar
    help-anchor="navbar__top"
    [title]="title()"
    [logoSrc]="logoSrc()"
    [logoAltText]="logoAltText()"
    [breadcrumbs]="breadcrumbs()"
  ></ups-navbar>
</header>
